var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 9.37172 19.9411 8.74285 19.8243 8.1323C19.7717 7.85594 19.5296 7.65621 19.2487 7.65621H10.0391C9.7152 7.65621 9.45312 7.91828 9.45312 8.24215V11.7578C9.45312 12.0816 9.7152 12.3437 10.0391 12.3437H14.7643C14.4699 12.9397 14.0642 13.4569 13.5877 13.892L16.8995 17.2037C18.805 15.3882 20 12.8336 20 10ZM10 4.6875C11.1496 4.6875 12.243 5.05258 13.162 5.74379C13.3943 5.91832 13.7222 5.89715 13.9282 5.68941L16.4287 3.18887C16.5449 3.0727 16.6072 2.91305 16.5998 2.74883C16.5924 2.58461 16.5168 2.43125 16.3909 2.32539C14.6017 0.825703 12.3317 0 10 0C6.5684 0 3.5368 1.7443 1.74465 4.39266L5.18402 7.83203C6.00457 5.98375 7.85074 4.6875 10 4.6875ZM10 20C12.2368 20 14.2966 19.25 15.961 18.0005L12.5871 14.6266C11.816 15.0609 10.9346 15.3125 10 15.3125C7.85074 15.3125 6.00457 14.0162 5.18402 12.168L1.74465 15.6073C3.5368 18.2557 6.5684 20 10 20ZM4.77281 10.8439C4.72793 10.5674 4.6875 10.2889 4.6875 10C4.6875 9.71105 4.72793 9.43258 4.77281 9.15605L1.09609 5.47934C0.400469 6.83793 0 8.37172 0 10C0 11.6283 0.400469 13.1621 1.09613 14.5206L4.77281 10.8439Z",
    fill: "#0195D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.9ab32ddfa4d3b77a9f5c3d8ba5d0f24d.svg";
export { ForwardRef as ReactComponent };